module.exports = __webpack_public_path__ + "static/media/food.3ed3d61a.svg";